<template>
    <div>
        <CheckoutStore v-if="isloggedIn" :baseUrl="baseUrl" :stripeKey="stripeKey" :googleMapsApiKey="googleMapsApiKey"></CheckoutStore>
        <checkUserSignup v-else :baseUrl="baseUrl" :stripeKey="stripeKey" :googleMapsApiKey="googleMapsApiKey"></checkUserSignup>
    </div>
</template>

<script>

import CheckoutStore from './CheckoutStore.vue'
import checkUserSignup from './checkUserSignup.vue'

export default {
    name: 'CheckoutComponent',
    components: {
        CheckoutStore,
        checkUserSignup
    },
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
        };
    },
    computed: {
        isloggedIn() {
            return this.$store.getters.isAuthenticated;
        },
    },
    mounted() {
        
    },

       
};
</script>